export default __webpack_public_path__ + "static/digital-86e49ebd877f5312a18758601b4fbc11.webp";